import React, { useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import AOS from "aos"; 
import "aos/dist/aos.css"; 

import FoodBanner from "../../../assets/food1.avif"; 

import FoodBrand1 from "../../../assets/darbar.jpg";
import FoodBrand2 from "../../../assets/taste of USA.jpg";
import FoodBrand3 from "../../../assets/punjab.jpg";
import FoodBrand4 from "../../../assets/punjab2.jpg";
import FoodBrand5 from "../../../assets/shakess.jpg";
import FoodBrand6 from "../../../assets/sandwitch2.jpg";

import CateringImage1 from "../../../assets/foodcatering1.webp";
import CateringImage2 from "../../../assets/foodcatering2.webp";
import CateringImage3 from "../../../assets/foodcatering3.jpg";

import Logo from "../../../assets/logo.png";
import ZomatoLogo from "../../../assets/zomato.jpg";
import SwiggyLogo from "../../../assets/swiggy.png";
import { Link } from "react-router-dom";

export default function Food() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <Container fluid className="py-5">
        <Row className="align-items-center">
          <Col lg={6}>
            <div
              data-aos="fade-right"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <img
                src={FoodBanner}
                alt="Shivek Foods"
                className="img-fluid shadow-lg rounded"
              />
            </div>
          </Col>

          <Col lg={6}>
            <div
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <h1>Welcome to Shivek Foods</h1>
              <h2>Where Taste Meets Excellence!</h2>
              <p className="lead" style={{textAlign:'justify'}}>
              Shivek Foods operates as a leading cloud kitchen with multiple outlets across
Madhya Pradesh, offering a wide variety of delicious cuisines for online ordering.
Customers can easily enjoy our flavourful dishes through popular food delivery apps
like Zomato and Swiggy. With a focus on quality, convenience, and customer
satisfaction, we provide an exceptional dining experience delivered right to your
doorstep.
              </p>
              <Link to="/contact">
                <Button variant="primary" size="lg">
                  Explore Our Menu
                </Button>
              </Link>
            </div>
          </Col>
        </Row>

        <Row className="my-5">
          <Col>
            <div
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="300"
            >
              <h2>Our Growth Story: 100+ Outlets and Expanding!</h2>
              <p >
              With over 10 successful outlets spread across Madhya Pradesh, Shivek Foods is
rapidly growing and making its mark in the food industry. From our humble
beginnings, we’ve grown into a thriving business that proudly serves a wide variety
of delicious cuisines through the following brands:
              </p>
            </div>
          </Col>
        </Row>

        <Row className="my-5">
          <Col>
            <h3
              className="text-center mb-4"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              Our Brands
            </h3>
            <Row>
              <Col
                xs={12}
                sm={6}
                md={4}
                data-aos="zoom-in"
                data-aos-duration="1000"
              >
                <Card className="m-4">
                  <Card.Img
                    variant="top"
                    src={FoodBrand1}
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>Vrindavan Darwar</Card.Title>
                    <Card.Text>
                      Offering a divine dining experience with traditional
                      flavors.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={4}
                data-aos="zoom-in"
                data-aos-duration="1000"
                data-aos-delay="200"
              >
                <Card className="m-4">
                  <Card.Img
                    variant="top"
                    src={FoodBrand2}
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>Taste of USA</Card.Title>
                    <Card.Text>
                      Bringing American fast food and snacks right to your door.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={4}
                data-aos="zoom-in"
                data-aos-duration="1000"
                data-aos-delay="400"
              >
                <Card className="m-4">
                  <Card.Img
                    variant="top"
                    src={FoodBrand3}
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>Rangeela Punjab</Card.Title>
                    <Card.Text>
                      A delightful fusion of Punjabi cuisine with a unique
                      twist.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={4}
                data-aos="zoom-in"
                data-aos-duration="1000"
                data-aos-delay="400"
              >
                <Card className="m-4">
                  <Card.Img
                    variant="top"
                    src={FoodBrand4}
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>Shahi Tadka</Card.Title>
                    <Card.Text>
                      For the rich and royal taste of North Indian cuisine.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={4}
                data-aos="zoom-in"
                data-aos-duration="1000"
                data-aos-delay="400"
              >
                <Card className="m-4">
                  <Card.Img
                    variant="top"
                    src={FoodBrand5}
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title> Midnight Shakes</Card.Title>
                    <Card.Text>
                      Perfect for those craving indulgent, creamy milkshakes at
                      any time.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={4}
                data-aos="zoom-in"
                data-aos-duration="1000"
                data-aos-delay="400"
              >
                <Card className="m-4">
                  <Card.Img
                    variant="top"
                    src={FoodBrand6}
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>The Sandwitch Box </Card.Title>
                    <Card.Text>
                      Serving up mouthwatering sandwiches that everyone loves.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-5">
          <Col>
            <div
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <h2>Catering Services for Your Special Events</h2>
              <p>
              At Shivek Foods, we understand the importance of good food in making any event
memorable. That’s why we offer catering services that bring the best taste and
quality to your celebrations. Whether it&#39;s a wedding, corporate event, birthday party,
or any special occasion, we provide:
              </p>
            </div>
            <Row>
              <Col md={4} data-aos="flip-left" data-aos-duration="1000">
                <img
                  src={CateringImage1}
                  alt="Catering 1"
                  className="img-fluid shadow-lg rounded"
                />
              </Col>
              <Col
                md={4}
                data-aos="flip-left"
                data-aos-duration="1000"
                data-aos-delay="200"
              >
                <img
                  src={CateringImage2}
                  alt="Catering 2"
                  className="img-fluid shadow-lg rounded"
                />
              </Col>
              <Col
                md={4}
                data-aos="flip-left"
                data-aos-duration="1000"
                data-aos-delay="400"
              >
                <img
                  src={CateringImage3}
                  alt="Catering 3"
                  className="img-fluid shadow-lg rounded"
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-5">
          <Col>
            <div
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <h2 className="text-center">Trusted by Leading Brands</h2>
              <p className="text-center">
                We are proud to be partnered with some of the biggest names in
                the industry, including:
              </p>
            </div>
            <Row className="justify-content-center">
              <Col
                md={3}
                className="text-center"
                data-aos="zoom-in"
                data-aos-duration="1000"
                data-aos-delay="200"
              >
                <img
                  src={Logo}
                  alt="Logo"
                  className="img-fluid"
                  style={{ maxHeight: "100px", objectFit: "contain" }}
                />
                <p>
                  IRCTC – Serving quality meals to travelers across the nation.
                </p>
              </Col>
              <Col
                md={3}
                className="text-center"
                data-aos="zoom-in"
                data-aos-duration="1000"
                data-aos-delay="400"
              >
                <img
                  src={ZomatoLogo}
                  alt="Zomato Logo"
                  className="img-fluid"
                  style={{ maxHeight: "100px", objectFit: "contain" }}
                />
                <p>Zomato – Reaching food lovers with a click of a button.</p>
              </Col>
              <Col
                md={3}
                className="text-center"
                data-aos="zoom-in"
                data-aos-duration="1000"
                data-aos-delay="600"
              >
                <img
                  src={SwiggyLogo}
                  alt="Swiggy Logo"
                  className="img-fluid"
                  style={{ maxHeight: "100px", objectFit: "contain" }}
                />
                <p>
                  Swiggy – Delivering hot, fresh meals right to your doorstep.
                </p>
              </Col>
            </Row>
            <p className="text-center mt-4">
              Our business has grown exponentially due to the trust of our
              customers and partners.
            </p>
          </Col>
        </Row>

        {/* Why Choose Us Section */}
        <Row className="my-5">
          <Col>
            <div
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <h2>Why Choose Shivek Foods?</h2>
              <ul>
                <li>Delicious and Consistent Taste</li>
                <li>Customer-Focused Service</li>
                <li>Nationwide Reach</li>
                <li>Expansion and Growth</li>
              </ul>
            </div>
          </Col>
        </Row>

        {/* Franchise Opportunities */}
        <Row className="my-5">
          <Col className="text-center">
            <div
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <h2>Join Our Family </h2>
              <p>
              We are expanding and invite passionate entrepreneurs to join our family. With a
proven business model, an established brand, and continuous support, we offer
lucrative franchise opportunities to help you be a part of our success story.
              </p>
              <Link to="/contact">
                <Button variant="primary" size="lg">
                  Learn More
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
